import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'prereport',
  type: 'node--prereport',
  attributes: {
    title: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'title',
    },
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    pr_comercial: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'pr_comercial',
    },
    pr_financiero: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'pr_financiero',
    },
    pr_juridico: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'pr_juridico',
    },
    pr_valoracionFinal: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'pr_valoracion_final',
    },
  },
  relationships: {
  },
};

export const PreReportService = createService(base, configuration, API_CONFIG.API);
export const PreReportModule = createModule(PreReportService, true);



// WEBPACK FOOTER //
// ./src/models/prereport.js